<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              style=" margin-top"
              @click="previousBooking"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2>Goods Receipt</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s">

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>Booking No.</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.bookingNo" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <!-- <md-layout md-flex='30'>
 </md-layout>
  <md-layout  md-flex=25>
  <md-layout md-flex="100">
    <label for="status">Status</label>
    <md-select name="status" id="status" v-model="goodReceived.status">
      <md-option value="">Select Status </md-option>
      <md-option value="New">New</md-option>
      <md-option value="inProgress">In Progress</md-option>
      <md-option value="Confirmed">Confirmed</md-option>
      <md-option value="Rejected">Rejected</md-option>
      <md-option value="Closed">Closed</md-option>
      <md-option value="Repeat">Repeat</md-option>

    </md-select>
  </md-layout>
  <span class="error" v-if="!goodReceived.status" >{{statusError}} </span>
          </md-layout>-->
        </md-layout>

        <md-layout md-gutter class="mrgtop-5px">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>ICD Name</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.icdName" disabled></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <md-layout md-gutter class="mrgtop-5px">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>ICD Address</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.icdAddress" disabled></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="40">
            <md-layout md-flex="100">
              <label>Shipper/Customer Name</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.shippingCustomerName" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="25">
            <md-layout md-flex="100">
              <label>Shipper/Customer Contact</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.shipperCustomerContact" disabled></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter class="mrgtop-5px">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Shipper/Customer Address</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.customerAddress" disabled></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Pickup Location</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.fromLocation" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="30">
            <md-layout md-flex="100">
              <label>Container Type</label>
              <b-form-input :formatter="capitalizeAll"
                v-model="goodReceivedauto.containerType"
                name="containerType"
                id="containerType"
                disabled
              ></b-form-input>
            </md-layout>
            <!-- <span class="error" v-if="!goodReceived.containerType">{{containerTypeError}} </span> -->
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="35">
            <md-layout md-flex="100">
              <label>Handover Location</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.toLocation" disabled></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
        </md-layout>

        <md-layout md-gutter class="mrgtop-5px">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Transportation Goods Details</label>
              <b-form-input :formatter="capitalizeAll" v-model="goodReceivedauto.transportationdetail" disabled></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="mrgtop-2per">
          <md-layout md-flex="40"></md-layout>

          <md-layout md-flex="40" v-if="driverNameLength>0">
            <md-button
              class="md-raised md-primary md-button-color"
              @click="openGenerateGRNDialog('dialog1')"
              id="addButtonLoader"
            >Generate GRN</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
          <md-layout md-flex="20"></md-layout>
        </md-layout>

        <hr>

        <div class="box" v-if="showGRNList.length>0">
          <div class="box-header">
            <h3 class="box-title">GRN Details</h3>
          </div>
          <!-- /.box-header
          <span class="error">{{ error.vehicleSelectError.length > 0 ? error.vehicleSelectError: "" }}</span>-->
          <div class="box-body">
            <table id="truckDetail2" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>GRN No.</th>
                  <th>driverName</th>
                  <th>Total Cost</th>
                  <th>Remarks</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in showGRNList" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.GRNSeries}}</td>
                  <td>{{item.masterdriverName}}</td>
                  <td>{{item.totalCost}}</td>
                  <td>{{item.remarks}}</td>

                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="showGRN(item.goodReceivedID)"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <!-- <md-layout md-gutter class="mrgtop-2per">

<md-layout md-flex='45'>

  </md-layout>

 <md-layout md-flex='35' v-if="driverNameLength>0">
<md-button class="md-raised md-primary md-button-color" @click="generateGrnForm" id="" > Submit</md-button>
 <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
  </md-layout>
  <md-layout md-flex='20'>
 </md-layout>

        </md-layout>-->
      </md-card-content>
    </md-card>
    <md-dialog class="HereDialog" md-open-from="#custom" md-close-to="#custom" ref="dialog1">
      <md-dialog-content>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Expense Details :</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <table id="truckDetail" class="table table-bordered table-striped">
              <md-layout md-gutter class="mrgtop-2per">
                <md-layout md-flex="5"></md-layout>
              </md-layout>

              <md-layout md-gutter v-if="driverNameLength>0">
                <md-layout md-flex="70"></md-layout>
                <md-layout md-flex="30">
                  <date-picker :format="selectDateFormat" lang="en" v-model="goodReceived.Date" id="Date"></date-picker>
                  <span class="error" v-if="!goodReceived.Date">{{DateError}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="40">
                  <md-layout md-flex="100">
                    <label>Driver Name</label>

                    <md-select name="driverName" id="driverName" v-model="goodReceived.driverName">
                      <md-option value>Select Driver Name</md-option>
                      <md-option
                        v-for="(item,index) in driverNameArr"
                        :key="index"
                        @selected="fetchVehicleNo"
                        :value="item.driverId"
                      >{{item.driverName}}</md-option>
                    </md-select>

                    <!-- <b-form-input :formatter="capitalizeAll" name="driverName" id="driverName" v-model="goodReceived.driverName"></b-form-input> -->
                  </md-layout>
                  <span class="error" v-if="!goodReceived.driverName">{{driverNameError}}</span>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Fuel Slip No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="FuelSlipNo"
                      id="FuelSlipNo"
                      v-model="goodReceived.FuelSlipNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.FuelSlipNo">{{FuelSlipNoError}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Vehicle No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="vehicleNo"
                      id="vehicleNo"
                      v-model="goodReceived.vehicleNo"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.vehicleNo">{{vehicleNoError}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>Re-Fueling Station Name</label>
                    <md-select
                      name="reFuelstation"
                      id="reFuelstation"
                      @change="refuelAddress1"
                      v-model="goodReceived.reFuelstation"
                    >
                      <md-option value>Select Refueling Station</md-option>
                      <md-option
                        v-for="(item,index) in refuelStationArr"
                        :key="index"
                        :value="item.refuelStationId"
                      >{{item.vendorName}}</md-option>
                    </md-select>
                    <!-- <b-form-input :formatter="capitalizeAll" name="reFuelstation" id="reFuelstation" v-model="goodReceived.reFuelstation"></b-form-input>-->
                  </md-layout>

                  <span class="error" v-if="!goodReceived.reFuelstation">{{reFuelstationError}}</span>
                </md-layout>

                <md-layout md-flex="15"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Container No.</label>
                    <b-form-input :formatter="capitalizeAll"
                      v-model="goodReceived.containerNo"
                      name="containerNo"
                      id="containerNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.containerNo">{{containerNoError}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <!-- <md-layout md-flex="100">
    <label>Quantity</label>
    <b-form-input :formatter="capitalizeAll" name="quantity" id="quantity" v-model="goodReceived.quantity" ></b-form-input>
                  </md-layout>-->
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="mrgtop-5px">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="90">
                  <md-layout md-flex="100">
                    <label>Re-Fueling Station Address</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="refuelAddress"
                      id="refuelAddress"
                      v-model="goodReceived.refuelAddress"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.refuelAddress">{{refuelAddressError}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Toll Card</label>
                    <b-form-input :formatter="capitalizeAll"
                      name="tollCard"
                      id="tollCard"
                      v-model="goodReceived.tollCard"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.tollCard">{{tollCardError}}</span>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Toll in cash</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="tollInCash"
                      id="tollInCash"
                      v-model="goodReceived.tollInCash"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.tollInCash">{{tollInCashError}}</span>
                </md-layout>

                <md-layout md-flex="15"></md-layout>

                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>Other Cash expenses</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="otherCashExpenses"
                      id="otherCashExpenses"
                      v-model="goodReceived.otherCashExpenses"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!goodReceived.otherCashExpenses"
                  >{{otherCashExpensesError}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Diesel (in Litres)</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="diesel"
                      id="diesel"
                      v-model="goodReceived.diesel"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.diesel">{{dieselError}}</span>
                </md-layout>

                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="15">
                  <md-layout md-flex="100">
                    <label>Diesel Price(in Rs.)</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="dieselPrice"
                      id="dieselPrice"
                      v-model="goodReceived.dieselPrice"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.dieselPrice">{{dieselPriceError}}</span>
                </md-layout>

                <md-layout md-flex="10"></md-layout>

                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Cash / Diesel Paid</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="cashDeiselPaid"
                      id="cashDeiselPaid"
                      v-model="goodReceived.cashDeiselPaid"
                      @keyup="finalActivityCost"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.cashDeiselPaid">{{cashDeiselPaidError}}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="mrgtop-2per">
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="55">
                  <md-layout md-flex="100">
                    <label>Remarks</label>
                    <b-form-textarea :formatter="capitalizeAll" name="remarks" id="remarks" v-model="goodReceived.remarks"></b-form-textarea>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.remarks">{{remarksError}}</span>
                </md-layout>
                <md-layout md-flex="15"></md-layout>
                <md-layout md-flex="20">
                  <md-layout md-flex="100">
                    <label>Total Cost</label>
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      min="0"
                      name="totalCost"
                      id="totalCost"
                      v-model="goodReceived.totalCost"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!goodReceived.totalCost">{{totalCostError}}</span>
                </md-layout>
              </md-layout>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="generateGrnForm">Ok</md-button>
        <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vehicle/goodsReceived");
      if (globalPermissionStatus("VehicleBookingFollow") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("VehicleBookingFollow")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      if (
        this.$sessionsStorage.get("storeQuotationId") != undefined &&
        this.$sessionsStorage.get("storeQuotationId") != "" &&
        this.$sessionsStorage.get("storeVehicleBookingId") != undefined &&
        this.$sessionsStorage.get("storeVehicleBookingId") != ""
      ) {
        this.getData();
      } else {
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      selectDateFormat,
      goodReceivedauto: {
        bookingNo: "",
        icdName: "",
        icdAddress: "",
        shippingCustomerName: "",
        shipperCustomerContact: "",
        customerAddress: "",
        icdAddress: "",
        toLocation: "",
        transportationdetail: "",
        fromLocation: "",
        containerType: ""
      },
      goodReceived: {
        goodReceivedID: "",
        Date: "",
        status: "",
        containerNo: "",
        driverName: "",
        FuelSlipNo: "",
        vehicleNo: "",
        // quantity: "",
        reFuelstation: "",
        refuelAddress: "",
        tollCard: "",
        tollInCash: "",
        otherCashExpenses: "",
        diesel: "",
        dieselPrice: "",
        cashDeiselPaid: "",
        remarks: "",
        totalCost: "",
        pdfGRN: "",
        clientId: this.$sessionsStorage.get("clientId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),
        vehicleBookingId: this.$sessionsStorage.get("storeVehicleBookingId"),
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        assignId: this.$sessionsStorage.get("storeAssignId")
      },
      alert: {
        content: "a",
        ok: "ok"
      },
      driverNameArr: [],
      driverNameLength: "",
      showGRNList: [],
      DateError: "",
      statusError: "",
      containerNoError: "",
      driverNameError: "",
      FuelSlipNoError: "",
      vehicleNoError: "",
      // quantityError: "",
      reFuelstationError: "",
      refuelStationArr: [],
      refuelAddressError: "",
      // containerTypeError: "",
      tollCardError: "",
      tollInCashError: "",
      otherCashExpensesError: "",
      dieselError: "",
      dieselPriceError: "",
      cashDeiselPaidError: "",
      remarksError: "",
      totalCostError: "",
      // getContainertype: [
      //   {
      //     containerType: "Aj"
      //   }
      // ],
      validateGoodReceived: true
    };
  },

  mounted() {
    this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker
  },
  computed: {
    // masterList() {
    //   return this.getContainertype;
    // }
  },
  methods: {
    onClose(type) {
      if (type != "cancel") {
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      }
    },

    showGRN(id) {
      this.$sessionsStorage.set("storeGenerateGrn", id);
      this.$router.push({
        path: "/vehicle/goodsReceived1"
      });
    },
    // masterCallback(item) {
    //   // let storeMaster = this.$store.getters.storeMasterList;
    //   let filterMasterList = this.getContainertype.filter(y => {
    //     return y.containerType == item.containerType;
    //   });
    // },
    validateGoodReceivedForm() {
      let validate_new = true;

      if (this.goodReceived.Date == "") {
        $("#Date").focus();
        this.DateError = "Select your date";
        validate_new = false;
      }
      if (this.goodReceived.driverName == "") {
        $("#driverName").focus();
        this.driverNameError = "Enter your driver Name";
        validate_new = false;
      }

      if (this.goodReceived.containerNo == "") {
        $("#containerNo").focus();
        this.containerNoError = "Enter your container no";
        validate_new = false;
      }
      if (this.goodReceived.driverName == "") {
        $("#driverName").focus();
        this.driverName = "Enter your driver name";
        validate_new = false;
      }
      if (this.goodReceived.FuelSlipNo == "") {
        $("#FuelSlipNo").focus();
        this.FuelSlipNoError = "Enter your fuel slip no";
        validate_new = false;
      }
      if (this.goodReceived.vehicleNo == "") {
        $("#vehicleNo").focus();
        this.vehicleNoError = "Enter your vehicle no.";
        validate_new = false;
      }
      // if (this.goodReceived.quantity == "") {
      //   $("#quantity").focus();
      //   this.quantityError = "Enter your quantity";
      //   validate_new = false;
      // }
      if (this.goodReceived.reFuelstation == "") {
        $("#reFuelstation").focus();
        this.reFuelstationError = "Enter your refuel station";
        validate_new = false;
      }
      if (this.goodReceived.refuelAddress == "") {
        $("#refuelAddress").focus();
        this.refuelAddressError = "Enter your refuel Address";
        validate_new = false;
      }
      if (this.goodReceived.containerNo == "") {
        $("#containerNo").focus();
        this.containerNoError = "Enter your refuel Address";
        validate_new = false;
      }
      // if (this.goodReceived.containerType == "") {
      //   $("#containerType").focus();
      //   this.containerTypeError = "Enter your refuel Address";
      //   validate_new = false;
      // }

      if (this.goodReceived.tollCard == "") {
        $("#tollCard").focus();
        this.tollCardError = "Enter toll card";
        validate_new = false;
      }

      if (this.goodReceived.contractDisplacmentDate == "") {
        $("#contractDisplacmentDate").focus();
        this.contractDisplacmentDateError = "Select Date";
        validate_new = false;
      }

      if (this.goodReceived.tollInCash == "") {
        $("#tollInCash").focus();
        this.tollInCashError = "Enter toll cash";
        validate_new = false;
      }

      if (this.goodReceived.otherCashExpenses == "") {
        $("#otherCashExpenses").focus();
        this.otherCashExpensesError = "Enter other cash expense";
        validate_new = false;
      }

      if (this.goodReceived.diesel == "") {
        $("#diesel").focus();
        this.dieselError = "Enter diesel in litres";
        validate_new = false;
      }

      if (this.goodReceived.dieselPrice == "") {
        $("#dieselPrice").focus();
        this.dieselPriceError = "Enter diesel Rate";
        validate_new = false;
      }
      if (this.goodReceived.cashDeiselPaid == "") {
        $("#cashDeiselPaid").focus();
        this.cashDeiselPaidError = "Enter cash paid";
        validate_new = false;
      }

      if (this.goodReceived.remarks == "") {
        $("#remarks").focus();
        this.remarksError = "Enter remarks";
        validate_new = false;
      }

      if (this.goodReceived.totalCost == "") {
        $("#totalCost").focus();
        this.totalCostError = "Enter total Cost";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateGoodReceived = false;
      } else {
        this.validateGoodReceived = true;
      }
    },
    JqueryFun() {
      return $(function() {
        return $("#quotationDetail").DataTable();
      });
    },
    masterFilter(list, query) {
      return this.getContainertype.filter(x => {
        return x.containerType.toLowerCase().includes(query.toLowerCase());
      });
    },

    openGenerateGRNDialog() {
      this.$refs["dialog1"].open();
      this.JqueryFun();
    },

    previousBooking() {
      this.$router.push({
        path: "/vehicle/vehicleBooking"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    addClient() {
      this.$router.push({
        path: "/client/addClient",
        name: "Add Clients"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },
    showQuotation() {
      this.$router.push({
        name: "Vehicle Quotation",
        path: "/vehicle/quotation"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    finalActivityCost() {
      let totalcost =
        parseFloat(this.goodReceived.tollCard) +
        parseFloat(this.goodReceived.tollInCash) +
        parseFloat(this.goodReceived.otherCashExpenses) +
        parseFloat(this.goodReceived.diesel) *
          parseFloat(this.goodReceived.dieselPrice) +
        parseFloat(this.goodReceived.cashDeiselPaid);

      this.goodReceived.totalCost = totalcost;
    },

    generateGrnForm() {
      let payload = {
        goodReceived: this.goodReceived,
        storeFollow: this.$store.getters.getData[0]
      };

      this.validateGoodReceivedForm();
      if (this.validateGoodReceived != false) {
        this.$refs["dialog1"].close();
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/addGenerateGrn_NewV3.php`,
          data: JSON.stringify(payload),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            // console.log("Updated", result);
            const { statusText, status, data } = result;
            if (result && data &&  status == 200) {
              if (data.msg == "Updated Successfully") {
                this.alert.content = "Data Updated  Successfully";
              } else {
                this.alert.content = "Added  Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");

              this.$refs["addPop"].open();

              this.$sessionsStorage.set(
                "storeGenerateGrn",
                data.goodReceivedID
              );
              this.$sessionsStorage.set(
                "storefollowActivityId",
                data.followActivityId
              );
              // this.$router.push({
              //   path: "/vehicle/vehicleBooking"
              // });
            }
          })
          .catch(error => {});
      }

      // this.$router.push({
      //   name: "Generate Invoice",
      //   path: "/vehicle/invoice"
      //   // params:{
      //   //   "userId":res.data.Id,
      //   // }
      // });
    },
    assignmentOrder() {
      this.$router.push({
        name: "Assignment Order",
        path: "/vehicle/assignmentOrder",
        name: "Assignment Order"
        // params:{
        //   "userId":res.data.Id,
        // }
      });
    },

    fetchVehicleNo() {
      let filter = this.driverNameArr.filter(x => {
        return x.driverId == this.goodReceived.driverName;
      });

      this.goodReceived.vehicleNo = filter[0].regdNo;
    },

    refuelAddress1() {
      let newbody = {
        reFuelstation: this.goodReceived.reFuelstation
      };
      console.log(newbody);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/fetchrefulAddress.php`,
        data: JSON.stringify(newbody),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.goodReceived.refuelAddress = data.refuelAddress;
          }
        })
        .catch(error => {});
    },
    getData() {
      let new_data = {
        vehicleBookingId: this.$sessionsStorage.get("storeVehicleBookingId"),
        salesBookingId: this.$sessionsStorage.get("salesBookingId"),
        clientId: this.$sessionsStorage.get("clientId"),
        quotationId: this.$sessionsStorage.get("storeQuotationId"),
        assignId: this.$sessionsStorage.get("storeAssignId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewGenerateGrn_NewV3.php`,

        data: JSON.stringify(this.goodReceived),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          // console.log("Updated", result);
          const { statusText, status, data } = result;
          if (result && data &&  status == 200) {
            this.refuelStationArr = data.refuelStationArray;
            this.goodReceivedauto = data.vehicleBookingList[0];
            this.driverNameArr = data.driver_master;
            this.driverNameLength = data.driver_master.length;

            this.getContainertype = data.containerTypeArray;

            this.goodReceived.dieselPrice = data.dieselRate;

            if (data.goodReceivedArray.length > 0) {
              this.showGRNList = data.goodReceivedArray;
              //   this.goodReceived = data.goodReceivedArray[0];
              //   this.$sessionsStorage.set(
              //     "storeGenerateGrn",
              //     data.goodReceivedArray[0].goodReceivedID
              //   );
            }
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 25% !important;
}

.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 5px;
}

.box {
  margin-top: 5%;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.mx-input-icon__calendar {
  margin-top: 0px !important;
}
.error {
  color: red;
}

.md-dialog-container.HereDialog.md-theme-default {
  z-index: 999999;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 100%;
}
.md-select-content {
  z-index: 999999999;
}
</style>


// WEBPACK FOOTER //
// goodsReceived.vue?41d54460